import { useState } from "react";
import { useTranslation } from "react-i18next";
import { AIChatWindow } from "@/components/application/ai-chat/ai-chat-window";
import { ChatTabs } from "@/components/application/ai-chat/chat-tabs";
import { ChatHistorySidebar } from "@/components/application/ai-chat/chat-history-sidebar";
import { useChatAI } from "@/components/application/ai-chat/chat-ai-context";
import { Button } from "@/components/base/buttons/button";
import { Tooltip } from "@/components/base/tooltip/tooltip";
import { Plus, Clock } from "@untitledui/icons";

export const ReceiverAskEvePage = () => {
    const { t } = useTranslation(['pages:dashboard', 'common']);
    const { createNewChat } = useChatAI();
    const [isHistoryOpen, setIsHistoryOpen] = useState(false);

    return (
        <div className="h-full flex flex-col">
            <div className="flex items-center justify-between px-4 py-4">
                <div>
                    <h1 className="text-lg font-semibold text-primary">{t('askEve.title', { ns: 'common' })}</h1>
                    <p className="text-tertiary mt-1">
                        {t('receiver.subtitle', { ns: 'pages:dashboard' })}
                    </p>
                </div>
                <div className="flex items-center gap-2">
                    <Tooltip title={t("aiChat.newChat")} placement="bottom">
                        <Button
                            onClick={createNewChat}
                            color="secondary"
                            size="sm"
                            iconLeading={Plus}
                        />
                    </Tooltip>
                    <Tooltip title={t("aiChat.chatHistory")} placement="bottom">
                        <Button
                            onClick={() => setIsHistoryOpen(true)}
                            color="secondary"
                            size="sm"
                            iconLeading={Clock}
                        />
                    </Tooltip>
                </div>
            </div>
            <ChatTabs />
            <div className="flex-1 min-h-0">
                <AIChatWindow />
            </div>
            <ChatHistorySidebar isOpen={isHistoryOpen} onClose={() => setIsHistoryOpen(false)} />
        </div>
    );
};

